export const getTime = (): string => {
  const currentDate: Date = new Date();

  const year: number = currentDate.getFullYear();
  const month: string = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day: string = String(currentDate.getDate()).padStart(2, '0');
  const hour: string = String(currentDate.getHours()).padStart(2, '0');
  const minute: string = String(currentDate.getMinutes()).padStart(2, '0');
  const second: string = String(currentDate.getSeconds()).padStart(2, '0');
  const offset: number = -currentDate.getTimezoneOffset() / 60; // Get the time zone offset in hours

  const timezoneOffset: string = (offset < 0 ? '-' : '+') + String(Math.abs(offset)).padStart(2, '0') + ':00';

  return `${year}-${month}-${day} ${hour}:${minute}:${second}${timezoneOffset}`;
};
